import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import bootstrap from "../../node_modules/bootstrap/dist/js/bootstrap";
import { Fancybox } from "../../node_modules/@fancyapps/ui/dist/fancybox/fancybox.esm";
import owl from "../../node_modules/owl.carousel/dist/owl.carousel";
import BuscaImoveis from "./components/busca-imoveis";
import Home from "./components/home";
import BuscaUnificada from "./components/busca-unificada";
import SelectV2 from "./components/select-v2";
import Motion from "./components/motion";

// Arrays de setas padrão reutilizados nos navText dos carrosséis Owl.
const NAV_ARROW_WHITE = [
    '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="white" stroke-opacity="0.1" style="stroke:white;stroke-opacity:0.1;"/><path d="M25.5 29L20.5 24L25.5 19" stroke="white" style="stroke:white;stroke-opacity:1;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="white" stroke-opacity="0.1" style="stroke:white;stroke-opacity:0.1;"/><path d="M23.5 29L28.5 24L23.5 19" stroke="white" style="stroke:white;stroke-opacity:1;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
];

const NAV_ARROW_BLOG = [
    '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#2B4841" stroke-opacity="0.1" style="stroke:#2B4841;stroke:color(display-p3 0.1686 0.2824 0.2549);stroke-opacity:0.1;"/><path d="M25.5 29L20.5 24L25.5 19" stroke="#D4AE61" style="stroke:#D4AE61;stroke:color(display-p3 0.8314 0.6824 0.3804);stroke-opacity:1;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#2B4841" stroke-opacity="0.1" style="stroke:#2B4841;stroke:color(display-p3 0.1686 0.2824 0.2549);stroke-opacity:0.1;"/><path d="M23.5 29L28.5 24L23.5 19" stroke="#D4AE61" style="stroke:#D4AE61;stroke:color(display-p3 0.8314 0.6824 0.3804);stroke-opacity:1;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
];

// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
// const ExampleModule2 = require('./components/example-2');
// const ExampleModule2 = require('./components/owl-carousel');

// Some convenient tools to get you started…
// import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
// import AnimateOnPageLinks from "./components/AnimateOnPageLinks";


// Initialise our components on jQuery.ready…
jQuery(function ($) {
    //     ExampleComponent1.init();
    //     ExampleModule2.init();
    //     ReplaceObfuscatedEmailAddresses.init();
    //     AnimateOnPageLinks.init();

    //FANCYBOX
    Fancybox.bind("[data-fancybox]", {
        backFocused: false
    });

    //MASK MONEY
    $('.input_currency').maskMoney({
        prefix: 'R$ ',
        allowNegative: false,
        thousands: '.',
        decimal: ',',
        affixesStay: false
    });
    $('.input_area').maskMoney({
        suffix: ' m²',
        allowNegative: false,
        thousands: '.',
        decimal: ',',
        affixesStay: false
    });

    //OWL CAROUSEL
    $('.owl-home-banner').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        dots: false,
        items: 1,
        lazyLoad: true,
        animateOut: 'fadeOut',
        autoplay: true,
        smartSpeed: 800,
        navText: NAV_ARROW_WHITE
    });

    $('.owl-home-exclusividades').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        dots: false,
        items: 1,
        lazyLoad: true,
        animateOut: 'fadeOut',
        // autoplay: true,
        smartSpeed: 800,
        navText: NAV_ARROW_WHITE
    });

    $('.owl-imoveis-mais-buscados').owlCarousel({
        loop: true,
        margin: 30,
        nav: true,
        dots: false,
        items: 1,
        lazyLoad: true,
        // autoplay: true,
        smartSpeed: 800,
        navText: [
            '<svg width="133" height="48" viewBox="0 0 133 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="black" stroke-opacity="0.1" style="stroke:black;stroke-opacity:0.1;"/><path d="M25.5 29L20.5 24L25.5 19" stroke="#222222" style="stroke:#222222;stroke:color(display-p3 0.1333 0.1333 0.1333);stroke-opacity:1;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M64.336 29L67.92 19.06H70.146L73.73 29H71.812L71 26.662H67.066L66.254 29H64.336ZM67.612 25.08H70.454L69.026 20.908L67.612 25.08ZM75.0425 21.58H76.6805L76.7225 22.784C77.1285 21.804 77.9685 21.412 78.9625 21.412C80.6005 21.412 81.4965 22.56 81.4965 24.226V29H79.6905V24.8C79.6905 23.568 79.3685 22.882 78.4165 22.882C77.4225 22.882 76.8625 23.568 76.8625 24.8V29H75.0425V21.58ZM84.0029 19.9H85.8229V21.58H87.7829V22.98H85.8229V26.718C85.8229 27.292 86.1029 27.586 86.6629 27.586H87.7829V29H86.3549C84.8289 29 84.0029 28.23 84.0029 26.718V22.98H82.8409V21.58H84.0029V19.9ZM88.6642 25.29C88.6642 22.938 90.1202 21.412 92.3322 21.412C94.2362 21.412 95.7902 22.7 95.8182 25.332L95.8322 25.78H90.5542C90.6382 27.012 91.2822 27.74 92.3322 27.74C93.0042 27.74 93.6062 27.362 93.8722 26.718L95.7202 26.858C95.2862 28.286 93.9422 29.168 92.3322 29.168C90.1202 29.168 88.6642 27.642 88.6642 25.29ZM90.5822 24.576H93.9562C93.8162 23.316 93.1162 22.84 92.3322 22.84C91.3522 22.84 90.7222 23.498 90.5822 24.576ZM97.2866 21.58H98.9806L99.0226 23.022C99.3026 22.056 99.8486 21.58 100.801 21.58H101.501V22.994H100.787C99.5966 22.994 99.1066 23.582 99.1066 24.772V29H97.2866V21.58ZM103.056 21.58H104.876V29H103.056V21.58ZM103.028 20.544V19.06H104.904V20.544H103.028ZM110.065 29.168C107.853 29.168 106.397 27.642 106.397 25.29C106.397 22.938 107.853 21.412 110.065 21.412C112.277 21.412 113.733 22.938 113.733 25.29C113.733 27.642 112.277 29.168 110.065 29.168ZM108.259 25.29C108.259 26.816 108.917 27.698 110.065 27.698C111.213 27.698 111.871 26.816 111.871 25.29C111.871 23.764 111.213 22.882 110.065 22.882C108.917 22.882 108.259 23.764 108.259 25.29ZM115.197 21.58H116.891L116.933 23.022C117.213 22.056 117.759 21.58 118.711 21.58H119.411V22.994H118.697C117.507 22.994 117.017 23.582 117.017 24.772V29H115.197V21.58Z" fill="#222222" style="fill:#222222;fill:color(display-p3 0.1333 0.1333 0.1333);fill-opacity:1;"/></svg>',
            '<svg width="133" height="48" viewBox="0 0 133 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="85.5" y="0.5" width="47" height="47" rx="23.5" stroke="black" stroke-opacity="0.1" style="stroke:black;stroke-opacity:0.1;"/><path d="M108.5 29L113.5 24L108.5 19" stroke="#222222" style="stroke:#222222;stroke:color(display-p3 0.1333 0.1333 0.1333);stroke-opacity:1;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.956 19.06C19.294 19.06 20.694 20.25 20.694 22.224C20.694 24.226 19.294 25.43 16.956 25.43H14.954V29H13.12V19.06H16.956ZM14.954 23.82H16.886C18.118 23.82 18.79 23.288 18.79 22.224C18.79 21.188 18.132 20.67 16.886 20.67H14.954V23.82ZM22.1948 21.58H23.8888L23.9308 23.022C24.2108 22.056 24.7568 21.58 25.7088 21.58H26.4088V22.994H25.6948C24.5048 22.994 24.0148 23.582 24.0148 24.772V29H22.1948V21.58ZM31.2404 29.168C29.0284 29.168 27.5724 27.642 27.5724 25.29C27.5724 22.938 29.0284 21.412 31.2404 21.412C33.4524 21.412 34.9084 22.938 34.9084 25.29C34.9084 27.642 33.4524 29.168 31.2404 29.168ZM29.4344 25.29C29.4344 26.816 30.0924 27.698 31.2404 27.698C32.3884 27.698 33.0464 26.816 33.0464 25.29C33.0464 23.764 32.3884 22.882 31.2404 22.882C30.0924 22.882 29.4344 23.764 29.4344 25.29ZM30.6244 20.474L31.5064 18.654H33.0744L31.8004 20.474H30.6244ZM41.536 21.566H43.566L40.99 25.22L43.664 29H41.634L39.912 26.424L38.19 29H36.146L38.862 25.206L36.258 21.566H38.288L39.912 24.002L41.536 21.566ZM45.3003 21.58H47.1203V29H45.3003V21.58ZM45.2723 20.544V19.06H47.1483V20.544H45.2723ZM48.8823 21.58H50.5203L50.5623 22.77C50.9263 21.902 51.6683 21.412 52.6483 21.412C53.6983 21.412 54.4543 21.972 54.7763 22.938C55.1403 21.93 55.9103 21.412 56.9743 21.412C58.4863 21.412 59.4243 22.392 59.4243 24.226V29H57.6043V24.8C57.6043 23.54 57.2123 22.882 56.4283 22.882C55.4763 22.882 54.9723 23.554 54.9723 24.8V29H53.3203V24.8C53.3203 23.554 52.9283 22.882 52.1583 22.882C51.2063 22.882 50.7023 23.582 50.7023 24.8V29H48.8823V21.58ZM64.463 29.168C62.251 29.168 60.795 27.642 60.795 25.29C60.795 22.938 62.251 21.412 64.463 21.412C66.675 21.412 68.131 22.938 68.131 25.29C68.131 27.642 66.675 29.168 64.463 29.168ZM62.657 25.29C62.657 26.816 63.315 27.698 64.463 27.698C65.611 27.698 66.269 26.816 66.269 25.29C66.269 23.764 65.611 22.882 64.463 22.882C63.315 22.882 62.657 23.764 62.657 25.29Z" fill="#222222" style="fill:#222222;fill:color(display-p3 0.1333 0.1333 0.1333);fill-opacity:1;"/></svg>'
        ],
        responsive: {
            968: {
                items: 2
            },
            1200: {
                items: 3
            }
        }
    });

    $('.owl-home-blog').owlCarousel({
        loop: true,
        margin: 30,
        nav: true,
        dots: false,
        items: 2,
        smartSpeed: 800,
        lazyLoad: false,
        navContainer: '.owl-nav-blog',
        navText: NAV_ARROW_BLOG
    });

    // Galeria do imóvel: slide central em destaque com os vizinhos aparecendo nas laterais.
    var $galeriaImovel = $('.owl-imovel-galeria-hero');
    $galeriaImovel.owlCarousel({
        loop: $galeriaImovel.children().length > 1,
        center: true,
        autoWidth: true,
        margin: 15,
        nav: false,
        dots: false,
        smartSpeed: 600,
        lazyLoad: false
    });
    $('.js-galeria-imovel-anterior').on('click', function () {
        $galeriaImovel.trigger('prev.owl.carousel');
    });
    $('.js-galeria-imovel-proxima').on('click', function () {
        $galeriaImovel.trigger('next.owl.carousel');
    });

    // "Voltar" retorna à busca de onde a pessoa veio (mantendo os filtros).
    $('.js-voltar').on('click', function (e) {
        if (document.referrer && document.referrer.indexOf(window.location.origin) === 0 && window.history.length > 1) {
            e.preventDefault();
            window.history.back();
        }
    });

    $('.owl-depoimentos').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        dots: false,
        items: 1,
        lazyLoad: true,
        // autoplay: true,
        smartSpeed: 800,
        navText: NAV_ARROW_WHITE
    });

    //MENU
    BuscaImoveis.init();
    Home.init();
    BuscaUnificada.init();
    SelectV2.init();
    Motion.init();

    var $menuMobile = $('#menuMobile');

    function alternarMenuMobile(abrir) {
        $menuMobile.toggleClass('is-aberto', abrir).attr('aria-hidden', !abrir);
        $('.js-menu-abrir').attr('aria-expanded', abrir);
        $('body').toggleClass('menu-mobile-aberto', abrir);
        if (abrir) {
            $menuMobile.find('.js-menu-fechar').trigger('focus');
        }
    }

    $('.js-menu-abrir').on('click', function () {
        alternarMenuMobile(true);
    });

    $('.js-menu-fechar').on('click', function () {
        alternarMenuMobile(false);
        $('.js-menu-abrir').trigger('focus');
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $menuMobile.hasClass('is-aberto')) {
            alternarMenuMobile(false);
        }
    });

    //COPY BUTTON
    $('.compartilhamento .copyButton').on('click', function (e) {
        e.preventDefault();
        navigator.clipboard.writeText($(this).attr('href')).then(function () {
            alert('Link copiado!')
        }, function () {
            alert('Falha ao copiar link. Verifique as permissões.')
        });

    });

    //MENU BUSCAR
    $('.fechar-busca').on('click', function () {
        $('#buscarImovelContent').removeClass('open');
    });

    //IMOVEIS FILTRO CHECKBOX
    // Usar delegação de eventos para garantir que funciona mesmo se os elementos forem adicionados dinamicamente
    $(document).off('click', '.btn_filtrar').on('click', '.btn_filtrar', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (!$('#imoveisLista').length) {
            alert('Erro: Elemento #imoveisLista não encontrado. Verifique se está na página correta.');
            return false;
        }
        
        if (typeof nucleoImob === 'undefined') {
            alert('Erro: configuração do núcleo não carregada (nucleoImob).');
            return false;
        }
        
        filtrarImoveis();
        return false;
    });

    //TROCAR ESTAGIO
    $('input[type=radio][name=estagio_main], input[type=radio][name=estagio]').on('change', function () {
        $("input[name=estagio][value=" + this.value + "]").prop('checked', true);
        $("input[name=estagio_main][value=" + this.value + "]").prop('checked', true);
        filtrarImoveis(true);
    });

    //LIMPAR FILTROS
    $('.limpar-filtros').on('click', function () {
        location.reload();
    });

    //LANCAMENTOS
    var pretensaoSync = $(".filtro_pretensao");
    pretensaoSync.on('change', function (e) {
        pretensaoSync.val(this.value);
        filtrarImoveis(true);
    });

    // var cidadesSync = $(".filtro_cidade, .filtro_cidade_secondary");
    // cidadesSync.on('change', function (e) {
    //     cidadesSync.val(this.value);
    //     filtrarImoveis(true);
    // });
    // $('.filtro_cidade_secondary').on('change', function () {
    //     filtrarImoveis(true);
    // });

    var cidadesSync = $(".filtro_cidade .form-check-input, .filtro_cidade_secondary .form-check-input");
    cidadesSync.on('change', function (e) {
        $(".form-check-input[value=" + $(this).val() + "]").prop("checked", this.checked);
        // console.log($('.filtro .filtro_cidade .form-check-input:checked[type=checkbox]').length);
        if ($('.filtro .filtro_cidade .form-check-input:checked[type=checkbox]').length) {
            if (($('.filtro .filtro_cidade .form-check-input:checked[type=checkbox]').length / 2) < 2) {
                $('.filtro_cidade .dropdown-toggle').html($(this).next('label').html());
            } else {
                $('.filtro_cidade .dropdown-toggle').html($('.filtro_cidade .dropdown-toggle').html() + ', ' + $(this).next('label').html());
            }
        } else {
            $('.filtro_cidade .dropdown-toggle').html('Selecione');
        }
        filtrarImoveis(true);
    });

    var tiposSync = $(".filtro_tipo .form-check-input, .filtro_tipo_secondary .form-check-input");
    tiposSync.on('change', function (e) {
        $(".form-check-input[value=" + $(this).val() + "]").prop("checked", this.checked);
        var $i = 0;
        if ($('.filtro .filtro_tipo .form-check-input:checked[type=checkbox]').length) {
            $('.filtro .filtro_tipo .form-check-input:checked[type=checkbox]').each(function () {
                if ($i < 1) {
                    $('.filtro_tipo .dropdown-toggle, .filtro_tipo_aux .dropdown-toggle').html($(this).next('label').html());
                } else {
                    $('.filtro_tipo .dropdown-toggle, .filtro_tipo_aux .dropdown-toggle').html($('.filtro_tipo .dropdown-toggle').html() + ', ' + $(this).next('label').html());
                }
                $i++;
            });
        } else {
            $('.filtro_tipo .dropdown-toggle').html('Selecione');
        }
        filtrarImoveis(true);
    });

    //IMOVEIS FILTRO ABRIR
    $('.filtros-toggle').on('click', function (e) {
        e.preventDefault();
        $('body').toggleClass('overflow-hidden');
        $('#imoveisFiltro').toggleClass('open');
    });

    $('.carregar-mais').on('click', function (e) {
        e.preventDefault();
        var page = $('#imoveisLista').data('page');
        $('#imoveisLista').data('page', page + 1);
        carregarImoveis();
    });

    //COLETA OS VALORES DOS FILTROS
    function getFiltros() {
        return {
            codigo: $('#codigo').val() ? $.trim($('#codigo').val()) : '',
            estagio: $('.filtro .filtro_estagio .form-check-input:checked[type=radio]').map(function () {
                return $(this).val();
            }).get(),
            tipo: $('.filtro .filtro_tipo .form-check-input:checked[type=checkbox]').map(function () {
                return $(this).val();
            }).get(),
            pretensao: $('.filtro .filtro_pretensao .form-check-input:checked[type=checkbox]').map(function () {
                return $(this).val();
            }).get(),
            cidade: $('.filtro .filtro_cidade .form-check-input:checked[type=checkbox]').map(function () {
                return $(this).val();
            }).get(),
            quartos: $('.filtro .filtro_quartos .form-check-input:checked[type=radio]').val(),
            valor_min: $('#valor_min').val() || '',
            valor_max: $('#valor_max').val() || '',
            area_min: $('#area_min').val() || '',
            area_max: $('#area_max').val() || ''
        };
    }

    //FILTRAR IMOVEIS
    function filtrarImoveis(keepOnChange) {
        if (!$('#imoveisLista').length) {
            return;
        }

        $('#imoveisLista').data('page', 1);
        $('.carregar-mais').removeClass('d-none');

        var postData = getFiltros();
        postData.action = 'filtro-imoveis';
        postData.tipo = JSON.stringify(postData.tipo);
        postData.pretensao = JSON.stringify(postData.pretensao);
        postData.cidade = JSON.stringify(postData.cidade);
        postData.nonce = nucleoImob.nonce;

        $('#imoveisLista').addClass('loading');
        $.ajax({
            type: 'POST',
            url: nucleoImob.ajaxurl,
            data: postData,
            success: function (response) {
                if (response && response.trim() !== '') {
                    $("#imoveisLista .row").html(response);
                } else {
                    $("#imoveisLista .row").html('<div class="col-12"><p>Nenhum imóvel encontrado.</p></div>');
                }
                $('#imoveisLista').removeClass('loading');
                if (!keepOnChange) {
                    $('#buscarImovelContent').removeClass('open');
                    $('#imoveisFiltro').removeClass('open');
                    $('body').removeClass('overflow-hidden');
                }
                ScrollTrigger.refresh();
                return false;
            },
            error: function (xhr, status, error) {
                $('#imoveisLista').removeClass('loading');
                alert('Erro ao filtrar imóveis. Por favor, tente novamente.');
            }
        });
        $.ajax({
            type: 'POST',
            url: nucleoImob.ajaxurl,
            data: $.extend({}, postData, { action: 'filtro-imoveis-qtd' }),
            success: function (response) {
                $("#total_imoveis").html(response);
                ScrollTrigger.refresh();
                return false;
            },
            error: function (xhr, status, error) {
                // Erro silencioso na contagem
            }
        });
    }

    //CARREGAR MAIS IMOVEIS
    function carregarImoveis(keepOnChange) {
        var page = $('#imoveisLista').data('page');

        var postData = getFiltros();

        if (!postData.valor_min) {
            postData.valor_min = $('#valor_min_default').val();
        }
        if (!postData.valor_max) {
            postData.valor_max = $('#valor_max_default').val();
        }
        if (!postData.area_min) {
            postData.area_min = $('#area_min_default').val();
        }
        if (!postData.area_max) {
            postData.area_max = $('#area_max_default').val();
        }

        postData.page = page;
        postData.action = 'carregar-imoveis';
        postData.tipo = JSON.stringify(postData.tipo);
        postData.pretensao = JSON.stringify(postData.pretensao);
        postData.cidade = JSON.stringify(postData.cidade);
        postData.nonce = nucleoImob.nonce;

        $('#imoveisLista').addClass('loading');
        $.ajax({
            type: 'POST',
            url: nucleoImob.ajaxurl,
            data: postData,
            success: function (response) {
                if (response.length != 0) {
                    $("#imoveisLista>.row").append(response);
                    $('#imoveisLista').removeClass('loading');
                    if (!keepOnChange) {
                        $('#buscarImovelContent').removeClass('open');
                        $('#imoveisFiltro').removeClass('open');
                        $('body').removeClass('overflow-hidden');
                    }
                    ScrollTrigger.refresh();
                } else {
                    $('.carregar-mais').addClass('d-none');
                }
                return false;
            }
        });
    }

});
